module.exports = __webpack_public_path__ + "img/vip_dialog_3.7f68b576.png";